module.exports = __webpack_public_path__ + "img/elementlengths_jasp.6afec58d.png";